module.exports = __webpack_public_path__ + "static/media/img-about-liquidGalaxy.cebb95b4.jpg";